import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '成员';
var name = 'departmentTree';
export default {
  icon: 'iconfont iconchengyuan',
  label: label,
  name: 'memberTree',
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {
        member: true,
        range: ['many', 'oneself']
      }
    };
  },
  props: function props() {
    return [{
      type: 'checkbox',
      field: 'range',
      title: '选择范围',
      options: [{
        label: '可选自己',
        value: 'oneself'
      }, {
        label: '可选多人',
        value: 'many'
      }]
    }, makeRequiredRule()];
  },
  basic: function basic() {}
};